const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
];
const emptyDate = new Date(1900, 0, 1, 0, 0, 0);

function dateToString(date) {
    return `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;
}

function timeToString(time) {
    const minutesZeroPadding = time.getMinutes() < 10 ? '0' : '';
    const secondsZeroPadding = time.getSeconds() < 10 ? '0' : '';
    return `${time.getHours()}:` +
        `${minutesZeroPadding}${time.getMinutes()}:` +
        `${secondsZeroPadding}${time.getSeconds()}`;
}

function timeToShortString(time) {
    const minutesZeroPadding = time.getMinutes() < 10 ? '0' : '';
    return `${time.getHours()}:${minutesZeroPadding}${time.getMinutes()}`;
}

function isDateEmpty(date) {
    return emptyDate.getTime() === date.getTime();
}

function getDate(dateString) {
    const currentDate = new Date(dateString);
    if (isDateEmpty(currentDate)) {
        return null;
    }

    return currentDate;
}

export default dateToString;

export { dateToString, timeToString, timeToShortString, getDate, isDateEmpty };
